<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
          <!--            <a-form-item label="租户ID">-->
          <!--              <a-input placeholder="请输入租户ID" v-model="queryParam.tenantId"></a-input>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="设备编号">
              <a-input placeholder="请输入设备编号" v-model="queryParam.serialNo"></a-input>
            </a-form-item>
          </a-col>
          <template>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="安装位置">
                <a-input placeholder="请输入安装位置" v-model="queryParam.cameraName"></a-input>
              </a-form-item>
            </a-col>
            <!--            <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
            <!--              <a-form-item label="学校名称">-->
            <!--                <a-input placeholder="请输入学校名称" v-model="queryParam.actionArea"></a-input>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <!--            <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
            <!--              <a-form-item label="位置类型(0=默认、1=入校、2=出校)">-->
            <!--                <a-input-->
            <!--                  placeholder="请输入位置类型(0=默认、1=入校、2=出校)"-->
            <!--                  v-model="queryParam.areaType"-->
            <!--                ></a-input>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">
                重置
              </a-button>
              <!--              <a @click="handleToggleSearch" style="margin-left: 8px">-->
              <!--                {{ toggleSearchStatus ? '收起' : '展开' }}-->
              <!--                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />-->
              <!--              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('相机表')">导出</a-button>
      <a-button type="primary" icon="import" @click="ImportCamera">导入相机信息</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <!--          <a-divider type="vertical" />-->
          <!--          <a-dropdown>-->
          <!--            <a class="ant-dropdown-link">-->
          <!--              更多-->
          <!--              <a-icon type="down" />-->
          <!--            </a>-->
          <!--            <a-menu slot="overlay">-->
          <!--              <a-menu-item>-->
          <!--                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">-->
          <!--                  <a>删除</a>-->
          <!--                </a-popconfirm>-->
          <!--              </a-menu-item>-->
          <!--            </a-menu>-->
          <!--          </a-dropdown>-->
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <gdCamera-modal ref="modalForm" @ok="modalFormOk"></gdCamera-modal>
    <ImportCameraInfo ref="importCameraInfoRef" />
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import GdCameraModal from './components/GdCameraModal'
import ImportCameraInfo from './components/ImportCameraInfo'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'CameraManage',
  mixins: [JeecgListMixin],
  components: {
    GdCameraModal,
    ImportCameraInfo,
  },
  data() {
    return {
      description: '相机表管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        // {
        //   title: '租户ID',
        //   align: 'center',
        //   dataIndex: 'tenantId',
        // },
        {
          title: '设备编号',
          align: 'center',
          dataIndex: 'serialNo',
        },
        {
          title: '安装位置',
          align: 'center',
          dataIndex: 'cameraName',
        },
        {
          title: '学校名称',
          align: 'center',
          dataIndex: 'actionArea',
        },
        {
          title: '位置类型(0=默认、1=入校、2=出校)',
          align: 'center',
          dataIndex: 'areaType',
        },
        // {
        //   title: '删除标志位',
        //   align: 'center',
        //   dataIndex: 'delFlag',
        // },
        // {
        //   title: '相机ID',
        //   align: 'center',
        //   dataIndex: 'regId',
        // },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          customRender: (_, record) => {
            return record.status == '1' ? (
              <a-tag color="green">在线</a-tag>
            ) : (
              <a-tag color="red">离线</a-tag>
            )
          },
        },
        // {
        //   title: '订阅地址',
        //   align: 'center',
        //   dataIndex: 'subscriptionUrl',
        // },
        // {
        //   title: '订阅号',
        //   align: 'center',
        //   dataIndex: 'subscriptionId',
        // },
        // {
        //   title: '布控号',
        //   align: 'center',
        //   dataIndex: 'surveillanceId',
        // },
        // {
        //   title: '布控相似度阀值',
        //   align: 'center',
        //   dataIndex: 'threshold',
        // },
        // {
        //   title: 'ip',
        //   align: 'center',
        //   dataIndex: 'ip',
        // },
        // {
        //   title: 'username',
        //   align: 'center',
        //   dataIndex: 'username',
        // },
        // {
        //   title: 'password',
        //   align: 'center',
        //   dataIndex: 'password',
        // },
        // {
        //   title: 'port',
        //   align: 'center',
        //   dataIndex: 'port',
        // },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/gdCamera/list',
        delete: '/gdCamera/delete',
        deleteBatch: '/gdCamera/deleteBatch',
        exportXlsUrl: '/gdCamera/exportXls',
        importExcelUrl: '/gdCamera/importExcel',
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    ImportCamera() {
      this.$refs.importCameraInfoRef.showModal()
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
